export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5482.85bf56d0.jpg";